// Defines temporary proxied API calls, e.g. the Companies House search
import axios from 'axios'

class StandaloneAPI {
  baseURL = process.env.VUE_APP_STANDALONE_API
  constructor () {
    this.instance = axios.create({ baseURL: this.baseURL })
  }
  setAuthorization (keyword, key) {
    this.instance.defaults.headers.Authorization = `${keyword} ${key}`
  }
  searchCompanies (params) {
    return this.instance.get('/search', { params })
      .then((response) => response.data)
  }
  createUser (params) {
    return this.instance.post('/register', params)
      .then((response) => response.data)
  }
  createTransaction (params) {
    return this.instance.post('/transaction', params)
      .then((response) => response.data)
  }
  setTransactionOwner (params) {
    return this.instance.post('/owner', params)
      .then((response) => response.data)
  }
}
export default new StandaloneAPI()
